import { combineReducers } from 'redux';

import destinationExplorer from './destinationExplorer';
import * as fromDestinationExplorer from './destinationExplorer/selectors';
import { filteredExploreAirline } from './filteredExploreAirline';

import type { DestinationExplorerState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/destinationExplorer';
import type { FilteredExploreAirlineState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/filteredExploreAirline';
import type { CombinedExploreAdvertsState } from '@web-platform/shared-universal-types/src/redux/state/shared/adverts';

const combinedExploreAdvertsReducers = combineReducers<CombinedExploreAdvertsState>({
  destinationExplorer,
  filteredExploreAirline,
});

export const INITIAL_STATE: CombinedExploreAdvertsState = combinedExploreAdvertsReducers(
  undefined,
  {
    type: '@@INIT',
  },
);

export default combinedExploreAdvertsReducers;

export const getDestinationExplorer = (
  state: CombinedExploreAdvertsState,
): DestinationExplorerState => fromDestinationExplorer.get(state.destinationExplorer);

export const getFilteredExploreAirline = (
  state: CombinedExploreAdvertsState,
): FilteredExploreAirlineState => state.filteredExploreAirline;
